import request from "../Requests/requests";
import { getSpentTime } from "./SpentTimeTask/getSpentTime";
import { getTodos } from "./getTodosToday";
import { getTodosIncoming } from "./getIncomingTodos";
import { getCalendarTodos } from "./CalendarService/getCalendarTodos";

export const copyTodo = (payload) => {
    return async dispatch => {
        try {
            const response = await request.post('/Task/Copy', {
                "userId": localStorage.getItem('userID'),
                "taskId": payload.id ? payload.id : payload
            })
            .then(() => dispatch(getSpentTime()))
            .then(() => dispatch(getTodos()))
            .then(() => dispatch(getTodosIncoming()))
            .then(() => {
                if (payload?.dateFromCalendarPage) {
                    dispatch(getCalendarTodos(payload?.dateFromCalendarPage));
                }
            })
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    } 
}